export const faqData = [
  {
    id: 1,
    question: "Can I prepay my Axis Bank car loan?",
    answer: "Yes, Axis Bank allows prepayment with nominal charges.",
  },
  {
    id: 2,
    question: "Does the EMI Calculator include processing fees? ",
    answer: "No, factor in an extra 1% processing fee while calculating costs.",
  },
  {
    id: 3,
    question: "Can I get a lower interest rate? ",
    answer:
      "Yes, maintaining a good credit score and choosing a shorter tenure can help.",
  },
];
